<template>
  <div id="currency-price-or-total">
    <CurrencyInput
      v-if="!isTotal"
      v-model="myPrice"
      :currency="currency"
      :label="labelPrice"
      :disabled="disabled"
      :showCurrency="showCurrency"
    />
    <CurrencyInput
      v-if="isTotal"
      v-model="myTotal"
      :currency="currency"
      :label="$t('common.totalWithoutCommission')"
      :disabled="disabled"
      :showCurrency="showCurrency"
    />
    <v-chip small class="mt-2" @click="changeIsTotal">
      <v-icon size="15" class="mr-1">mdi-swap-horizontal</v-icon>
      {{
        isTotal
          ? $t('views.common.currencyPriceOrTotal.price')
          : $t('views.common.currencyPriceOrTotal.total')
      }}
    </v-chip>
  </div>
</template>

<script>
import CurrencyInput from '@/views/components/common/CurrencyInput'

export default {
  components: { CurrencyInput },
  props: {
    value: {
      type: null,
      default: null,
    },
    positionNumber: {
      type: null,
      default: null,
    },
    currency: {
      type: String,
      default: null,
    },
    labelPrice: {
      type: String,
      default: null,
    },
    labelTotal: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showCurrency: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    myPrice: null,
    myTotal: null,
    isTotal: false,
  }),
  watch: {
    value: {
      handler() {
        this.myPrice = this.value
      },
      immediate: true,
    },
    myPrice() {
      this.$emit('input', this.myPrice)
    },
    positionNumber() {
      if (this.isTotal) {
        this.updateMyPrice()
      }
    },
    myTotal() {
      this.updateMyPrice()
    },
  },
  methods: {
    updateMyPrice() {
      if (!this.positionNumber || (!this.myTotal && this.myTotal !== 0)) this.myPrice = null
      else this.myPrice = this.myTotal / this.positionNumber
    },
    changeIsTotal() {
      if (!this.isTotal) {
        if (this.positionNumber && (this.myPrice || this.myPrice === 0))
          this.myTotal = this.myPrice * this.positionNumber
        this.isTotal = true
      } else {
        this.isTotal = false
      }
    },
  },
}
</script>

<style lang="scss">
#currency-price-or-total {
  .change-link {
    font-size: 13px;
  }
}
</style>
